import { axiosClient, axiosNuxt } from '~/common/js/axios'
import { transLang } from '~/common/js/storeUtil'
import Cookies from 'js-cookie'
import get from 'lodash/get'
import qs from 'qs'
import { COUNTRY_BIZ_TYPE_ENUM, KYC_ERROR_CODE, PRO_TRADE_MODE_ENUM } from './const'
import { useIndexStore } from '~/store';

import { countryNameMap } from '~/common/js/country-name'

function underscoreToSlash(string) {
  return string.replace(/_/, '/')
}

/**
 * 根据交易对名称查询交易对 ID
 * @TODO 2022-09-14 msl 后续可以对这里通过优化币种查询方法，通过map映射方式，优化性能
 * @param symbolName 交易对名称, 以_分隔，如 BMX_ETH
 * @param symbolList 交易对列表
 * @param coinNameKey 币种名称的key值
 */
export function getSymbolIdByName(symbolName = '', symbolById = {}, coinNameKey = 'name') {
  let symbolId
  if (symbolName.indexOf('_') === -1) {
    return symbolId
  }
  const slashSymbolName = underscoreToSlash(symbolName)

  // @TODO perf 通过symbolName从长列表中反查找id比较影响性能
  Object.keys(symbolById).some((id) => {
    const entity = symbolById[id]
    if (encodeURIComponent(entity[coinNameKey]) === encodeURIComponent(slashSymbolName)) {
      symbolId = id
      return true
    }
  })

  return symbolId
}

/**
 * 取消一系列同样订阅
 * @param {*} subKey 订阅的Key值 例如depth
 */
export function cancelSeriesWsItems(websocketSub, subKey) {
  const subItems = websocketSub.getSubItems()
  const tempSubs = []
  subItems.forEach((subObj, index) => {
    if (subObj.subscribe === subKey) {
      subObj.subscribeObj.subscribe = `${subKey}_cancel`
      if (subObj.subscribeObj.event === 'addChannel') subObj.subscribeObj.event = 'cancelChannel'
      websocketSub.createSubject(subObj.subscribeObj)
      // subItems.splice(index, 1)
    } else {
      tempSubs.push(subObj)
    }
  })

  websocketSub.setSubItems(tempSubs)
}

/**
 * 更新 symbolId
 * update: [2023-05-15 inm]
 * 新增杠杆逻辑校验，如果参数中带了type=margin，需要校验当前交易对是否开通杠杆
 * 如果当前交易对没有开通杠杆，需要跳转到btc的杠杆页面
 * 返回布尔值，true=symbol可用，false=symbol不可用
 */
export async function updateSymbolId(store, query, redirect) {
  const locale = store.state.locale
  // btc交易对的symbolId为53
  const BTC_SYMBOL_ID = 53
  let finalSymbolId = BTC_SYMBOL_ID
  // 存在query.symbol时
  if (query && query.symbol) {
    const { type, layout, theme } = query
    // 如果参数里带了杠杆参数
    if (type === PRO_TRADE_MODE_ENUM.MARGIN.toLowerCase()) {
      // 查看当前交易对是否开通杠杆
      // 如果杠杆交易对列表为空，需要请求一次
      if (!store.state.margin.symbolList.length) {
        await store.dispatch('margin/getSymbolList')
      }
      // 如果当前交易对不在杠杆交易对列表中，需要跳转到btc的杠杆页面
      const currentMarginSymbolId = getSymbolIdByName(
        decodeURIComponent(query.symbol),
        store.state.margin.symbolMap,
        'tradeMappingName'
      )
      if (!currentMarginSymbolId) {
        if (+store.state.trade?.symbolInfo?.symbol === +BTC_SYMBOL_ID) {
          delete query.symbol
          const queryStr = qs.stringify({
            ...query,
          })
          return redirect(`/trade/${locale}?${queryStr}`)
        } else {
          store.dispatch('trade/changeSymbol', { symbolId: BTC_SYMBOL_ID, layout, theme, type })
          store.commit('trade/SET_SYMBOLID', BTC_SYMBOL_ID)
          return
        }
      }
    }
    // 查询symbol是否可用
    const currentSymbolId = getSymbolIdByName(decodeURIComponent(query.symbol), store.state.trade.symbolById)
    // 如果可用
    if (currentSymbolId) {
      store.commit('trade/SET_SYMBOLID', currentSymbolId)
      finalSymbolId = currentSymbolId
      // updateOrderQueryConfig(store.commit, currentSymbolId);
    } else {
      // 如果没有找到这个交易对，可能新上的交易对，再请求一次看看
      if (process.client) {
        const ret = await axiosClient({
          url: '/gw-api/ds/pairs',
          method: 'GET',
          params: {
            local: transLang(store.state.locale, store),
          },
        })

        if (ret?.success) {
          // console.log('from updateSymbolId')
          store.commit('trade/SET_SYMBOL_LIST', ret.data)
          // store.dispatch('trade/subscribeAllCoin')
        }

        const currentSymbolId = getSymbolIdByName(decodeURIComponent(query.symbol), store.state.trade.symbolById)
        if (currentSymbolId) {
          store.commit('trade/SET_SYMBOLID', currentSymbolId)
          finalSymbolId = currentSymbolId
          // updateOrderQueryConfig(store.commit, currentSymbolId);
        } else {
          delete query.symbol
          const queryStr = qs.stringify({
            ...query,
            // layout: query.layout,
            theme: query.theme,
          })
          return redirect(`/trade/${locale}?${queryStr}`)
        }
      } else {
        delete query.symbol

        const queryStr = qs.stringify({
          ...query,
          // layout: query.layout,
          theme: query.theme,
        })
        return redirect(`/trade/${locale}?${queryStr}`)
      }
    }
  } else {
    // 设置默认的symbolID为53
    store.commit('trade/SET_SYMBOLID', BTC_SYMBOL_ID)
    finalSymbolId = BTC_SYMBOL_ID
    // updateOrderQueryConfig(store.commit, 53);
  }
  // 订阅交易对, 仅在客户端执行，避免服务端报错, 多发起一次没关系
  if (process.client) {
    store.dispatch('trade/subscribeCoins', { symbolIds: [finalSymbolId] })
  }
}

// 忽略kyc限制的机构用户kycLevel
const ignoreKycLevel = [10, 11]

/**
 * 获取kyc等级、所属国家是否限制
 */
export const getKycData = function (type) {
  // const token = Cookies.get('accessToken')

  const kycInfoPromise = axiosClient({
    method: 'GET',
    url: '/gw-api/user-center/user/verification/getInfo',
    // headers: {
    //   Authorization: token,
    // },
  })

  // 根据类型调用不同的国家限制查询方法
  // const typeLimitFnMap = {
  //   earn: getCommunalimitCountry
  // }
  const limitFn = (type && getCommunalimitCountry) || getActionLimitCountry
  const kycLimitCountryPromise = limitFn(type)

  return Promise.all([kycInfoPromise, kycLimitCountryPromise]).then((results) => {
    const kycInfo = results[0]
    const kycLimitCountry = results[1]
    const kycLimitCountryDatas = kycLimitCountry.map((code) => {
      return countryNameMap[code]
    })

    if (kycInfo?.success) {
      const kycLevel = get(kycInfo, 'data.kycLevel', 0)
      const ignoreKyc = ignoreKycLevel.includes(kycLevel)
      return {
        success: true,
        kycLevel,
        isLimitCountry: kycLimitCountry.includes(get(kycInfo, 'data.country', '')),
        ignoreKyc,
        limitCountrys: kycLimitCountryDatas,
      }
    }
    return {
      success: false,
    }
  })
}

/**
 * 封装的kyc校验逻辑
 * @returns
 */
export const validateKYC = async function (store, level = 1) {
  let { success, kycLevel, ignoreKyc } = await getKycData()

  if (!success) return false

  if (!store.getters['account/is2FA']) {
    store.commit('SHOW_VERIFICATION_LIMIT_DIALOG', 'WITHDRAW_SELL')
    return false
  }

  if (!ignoreKyc && kycLevel < 1 && level > 0) {
    store.commit('SHOW_VERIFICATION_LIMIT_DIALOG', 'WITHDRAW_SELL')
    return false
  }

  if (!ignoreKyc && kycLevel < 2 && level > 1) {
    store.commit('SHOW_VERIFICATION_LIMIT_DIALOG', 'TRADE_EARN_SHOOT_FUTURE')
    return false
  }

  return true
}

/**
 * 封装的kyc校验逻辑-新流程
 * @returns
 */
export const validateKYCFlow = async function (store, level = 1, options) {
  let { success, kycLevel, ignoreKyc, isLimitCountry } = await getKycData(options?.type)

  if (!success) return false

  const isApp = !!window.jsBridge && typeof window.jsBridge.invoke === 'function'

  if (isApp && !ignoreKyc && kycLevel < level) {
    const kycData = {
      needKyc1: kycLevel < 1,
      needKyc2: level > 1,
      need2Fa: options?.check2FA && !store.getters['account/is2FA'],
    }
    if (options?.bizType) {
      kycData.bizType = options.bizType
    }
    window.jsBridge.invoke('verifyKyc', kycData)
    return
  }

  if (!ignoreKyc && kycLevel < 1 && level > 0) {
    store.commit('VERIFY_KYC_FLOW_START', {
      targetKycLevel: level,
      startKycLevel: 0,
    })
    return false
  }

  if (!ignoreKyc && kycLevel < 2 && level > 1) {
    store.commit('VERIFY_KYC_FLOW_START', {
      targetKycLevel: level,
      startKycLevel: 1,
    })
    return false
  }

  if (!ignoreKyc && options?.check2FA && !store.getters['account/is2FA']) {
    store.commit('SHOW_VERIFICATION_LIMIT_DIALOG', 'WITHDRAW_SELL')
    return false
  }

  if (!ignoreKyc && options?.checkLimitCounrty && isLimitCountry) {
    store.commit('SHOW_KYC_COUNTRY_LIMIT_DIALOG')
    return false
  }

  return true
}
/*
 * 根据错误码显示kyc验证弹窗，需要走kyc验证流程的会返回false，不需要返回true
 * @returns
 */
export const verifyKycByErrorCode = function (errorCode, options) {
  const store = useIndexStore()
  const isApp = !!window.jsBridge
  const kycData = {
    needKyc1: false,
    needKyc2: false,
    need2Fa: !!options?.check2FA && !store.account.is2FA,
    needDepositButton: false,
  }
  if (options?.bizType) {
    kycData.bizType = options.bizType
  }

  if (KYC_ERROR_CODE[errorCode] === 1) {
    if (isApp) {
      kycData.needKyc1 = true
      kycData.needKyc2 = false
      window.jsBridge.invoke('verifyKyc', kycData)
    } else {
      store.VERIFY_KYC_FLOW_START({
        targetKycLevel: 1,
        startKycLevel: 0,
      })
    }
    return false
  }
  if (KYC_ERROR_CODE[errorCode] === 2) {
    if (isApp) {
      kycData.needKyc1 = false
      kycData.needKyc2 = true
      window.jsBridge.invoke('verifyKyc', kycData)
    } else {
      store.VERIFY_KYC_FLOW_START({
        targetKycLevel: 2,
        startKycLevel: 1,
      })
    }
    return false
  }
  if (KYC_ERROR_CODE[errorCode] === 'limitCountry') {
    store.SHOW_KYC_COUNTRY_LIMIT_DIALOG_WIDTH_DATA({
      countryCodeList: options?.extraData?.forbiddenCountries || [],
    })
    return false
  }

  return true
}

/**
 * 业务限制国家、地区列表
 */
export const getActionLimitCountry = async function () {
  const res = await axiosClient({
    method: 'GET',
    url: '/gw-api/user-center/settings/forbidden/country',
  })
  if (res?.success) {
    return get(res, 'data.countryList', [])
  }
  return []
}

/**
 * 业务限制国家、地区列表 -- 公共
 */
export const getCommunalimitCountry = async function (bizType) {
  const res = await axiosClient({
    method: 'GET',
    url: '/gw-api/user-center/settings/communal/forbidden/country/get',
    params: {
      bizType,
    },
  })
  if (res?.success) {
    return get(res, 'data.countryList', [])
  }
  return []
}

/**
 * 查询用户合约类型，
 * @returns 0是没有过kyc，1是币安合约，2是自研合约
 */
export const getUserContractType = async function () {
  // const token = Cookies.get('accessToken')
  try {
    const res = await axiosClient({
      method: 'GET',
      url: '/gw-api/user-center/contract/type',
      // headers: {
      //   Authorization: token,
      // },
    })
    if (res?.success) {
      return get(res, 'data', -1)
    }
    return -1
  } catch (error) {
    return error
  }
}

/**
 * 用来获取配置项
 * @param {*} key key值
 * @param {*} needSetInStore 是否储存在 sessionStorage
 * @param {*} needSetInLSStore 是否储存在 localStorage
 */
export async function getViewConfig(key, needSetInStore, needSetInLSStore) {
  if (process.client) {
    try {
      const res = await axiosClient({
        method: 'POST',
        url: '/gw-api/content/front/lowCode/queryData',
        data: {
          key,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (res?.success && res?.data) {
        const retDataStr = get(res, 'data', null)
        const retData = JSON.parse(retDataStr)
        if (retData && needSetInStore) {
          window.sessionStorage.setItem(key, retDataStr)
        }
        if (retData && needSetInLSStore) {
          window.localStorage.setItem(key, retDataStr)
        }
        return retData
      }
      return null
    } catch (error) {
      return null
    }
  } else {
    try {
      const res = await axiosNuxt({
        method: 'POST',
        url: '/content/front/lowCode/queryData',
        data: {
          key,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (res?.success && res?.data) {
        const retDataStr = get(res, 'data', null)
        const retData = JSON.parse(retDataStr)
        if (retData && needSetInStore) {
          window.sessionStorage.setItem(key, retDataStr)
        }
        if (retData && needSetInLSStore) {
          window.localStorage.setItem(key, retDataStr)
        }
        return retData
      }
      return null
    } catch (error) {
      return null
    }
  }
}
export const isIpAllowed = (blockCountry = []) => {
  return axiosClient({
    method: 'get',
    url: '/gw-api/user-center/current-ip',
  })
    .then((resp) => {
      if (resp.success) {
        const { countryCode } = resp.data
        let allowed = true
        if (blockCountry.includes(countryCode)) {
          allowed = false
        }
        return { allowed }
      }
    })
    .catch(() => {
      return { isBlock: true }
    })
}

export const useCountryList = async (store, type = COUNTRY_BIZ_TYPE_ENUM.REGISTER) => {
  console.log('store',store.store.country)
  const storeMap = new Map([
    [
      COUNTRY_BIZ_TYPE_ENUM.ALL,
      {
        store: store.store.country.allCountryList,
        commit: 'country/SET_ALL_COUNTRY_LIST',
      },
    ],
    [
      COUNTRY_BIZ_TYPE_ENUM.REGISTER,
      {
        store: store.store.country.regCountryList,
        commit: 'country/SET_REG_COUNTRY_LIST',
      },
    ],
    [
      COUNTRY_BIZ_TYPE_ENUM.KYC,
      {
        store: store.store.country.kycCountryList,
        commit: 'country/SET_KYC_COUNTRY_LIST',
      },
    ],
    [
      COUNTRY_BIZ_TYPE_ENUM.ALL_AREA_CODE,
      {
        store: store.store.country.allAreaCodeList,
        commit: 'country/SET_ALL_AREA_CODE_LIST',
      },
    ],
  ])
  const currentStoreInfo = storeMap.get(type)
  if (!currentStoreInfo) {
    return Promise.resolve([])
  }
  if (currentStoreInfo.store.length) {
    return Promise.resolve(currentStoreInfo.store)
  }
  const res = await axiosClient({
    url: '/gw-api/user-center/front/country/query',
    params: {
      bizType: type,
      version: -1, // -1表示最新版本
    },
  })
  if (!res?.success) {
    return Promise.resolve([])
  }
  store.commit(currentStoreInfo.commit, res?.data?.countryList || [])
  return Promise.resolve(res?.data?.countryList || [])
}
